import { getPickerInputStyle } from './DatePicker.styles'
import { DateIcon, TimeIcon } from '../../svg'
import { cn } from '../../utils'
import React, { forwardRef, useEffect, useState } from 'react'
import { DatePickerInputProps } from './types'

/**
 * DatePickerInput component that forwards the ref to the underlying input element.
 *
 * @param value - Value of the input
 * @param placeholder - Placeholder text for the input
 * @param onClick - Callback function to open the date picker
 * @param onChange - Callback function to handle changes in the input
 * @param className - Additional className for styling
 * @param isTime - Boolean indicating if the time icon should be shown
 */
const DatePickerInput = forwardRef<HTMLInputElement, DatePickerInputProps>(
    (
        {
            value,
            placeholder,
            onClick,
            onChange,
            className,
            isTime = false,
            disabled = false,
        },
        ref
    ) => {
        const [valueInput, setValueInput] = useState(value)

        useEffect(() => {
            setValueInput(value)
        }, [value])

        const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            setValueInput(e.target.value)
            onChange && onChange(e)
        }

        return (
            <div className={cn(getPickerInputStyle(disabled), className)}>
                <input
                    ref={ref}
                    className={cn(
                        '!placeholder:font-light h-full w-full cursor-pointer bg-background-base !text-color-title outline-none',
                        disabled && 'bg-background-disabled/10'
                    )}
                    type="text"
                    placeholder={placeholder}
                    value={valueInput}
                    onChange={handleInputChange}
                    onClick={onClick}
                    readOnly={true}
                />
                <div
                    onClick={onClick}
                    className="flex items-center justify-center pb-2 pr-1 align-middle"
                >
                    <span className="pointer-events-auto">
                        {isTime ? <TimeIcon /> : <DateIcon />}
                    </span>
                </div>
            </div>
        )
    }
)

export { DatePickerInput }
